import WooCommerceRestApi from "@woocommerce/woocommerce-rest-api";
const axios = require('axios');

const apiWCP = new WooCommerceRestApi({
  url: "http://localhost:8000",
  consumerKey: 'ck_a1da091eeca455592b89bf49cdb0bac551be15d0',
  consumerSecret: "cs_348495b71f066cd76a996a7b7e16545c423b7c3b",
  version: "wc/v3"
});
//asynchroniczny forEach ;)
async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

const ajaxLoop = async (dataTermID, main) => {
  jQuery.ajax({
    type: 'POST',
    dataType: 'json',
    url: ajax.url,
    data: {
      action: 'get_product_list',
      cat: dataTermID
    },
    beforeSend: function () {

      
      main.innerHTML = '<div class="spinner"><i class="fa fa-spinner fa-spin"></i></div>';
      
    },
    success: function (response) {
      console.log(response);
      clearLoopBox(main);
      if(response.length > 0) {
        asyncForEach(response, async (item) => {
          main.innerHTML += item;
        })
      } else {
        main.innerHTML += '<h3>Brak produktów w wybranej kategorii</h3>';
      }
      
    },
    cache: false,
  });
}

const clearLoopBox = async (main) => {
  main.innerHTML = '';
}

export const getProductsCart = async () => {
  const main = document.getElementById('loop');
  let dataTermID = [];
  dataTermID.push(main.getAttribute('data-term'));
  const checkboxes = document.querySelectorAll('.section_woocommerce_small_category__ageFilter input');

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      dataTermID = [];
      dataTermID.push(main.getAttribute('data-term'));
      checkboxes.forEach(item => {
        if(item.checked == true) {
          dataTermID.push(item.value);
        }
      })

      console.log(dataTermID);
      clearLoopBox(main);
      ajaxLoop(dataTermID, main);
    })
  })

  console.log(checkboxes);
  await ajaxLoop(dataTermID, main);
}